
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApplicationDataService {
  private env: any;
  private envUrl: string;

  constructor(private httpClient: HttpClient) {
    this.envUrl = '/assets/env/environment.json';
  }

  resolve(): Observable<any> {
    return this.initEnvironments();
  }

  public getEnvironment(): any {
    return this.env;
  }

  initEnvironments(): Observable<any> {
    if (!this.env) {
      return this.httpClient.get(this.envUrl).pipe(
        map((res: any) => {
          this.env = {
            ...res,
            APIcalling: res.useProxy ? `${window.location.protocol}//${window.location.host}` : res.APIcalling
          };
          // this.env = res;
          return this.env;
        })
      );
    } else {
      return of(this.env);
    }
  }

  fetchVersionJson(): Observable<any> {
    return this.httpClient.get<any>('./assets/version/version.json');
  }

  fetchVersionJsonFromServer(): Observable<any> {
    return this.httpClient.get<any>('./assets/version/version.json');
  }
}
